/* ContactModal — text in English and German (same shape in both).
   The interest options are shown translated, but the e-mail sent to us
   always carries the English option names (see INTEREST_OPTIONS). */
import { ByLang, useL } from "i18n/lang";

const en = {
  subtitle: "Get in touch",
  closeAria: "Close",
  sentTitle: "Message sent!",
  sentBody: "We'll get back to you soon.",
  close: "Close",
  firstName: "First Name",
  lastName: "Last Name",
  firstNamePh: "Jane",
  lastNamePh: "Doe",
  email: "Email",
  emailPh: "jane@example.com",
  code: "Code",
  phone: "Phone",
  optional: "(optional)",
  interestsLabel: "Dreamfulness — I am keen on",
  // Same order as INTEREST_OPTIONS in Contactmodal.tsx
  interestOptions: [
    "Exploration | Online | Free",
    "Guided | Online | Offline",
    "Weekend | Retreat",
    "DIY | KIT",
    "Others",
  ],
  message: "Message",
  messagePh: "Your message...",
  sending: "Sending…",
  send: "Send Message",
  followUs: "Follow us",
  errors: {
    required: "Required",
    invalidEmail: "Invalid email",
    invalidPhone: "Invalid number",
    selectOne: "Select at least one option",
    submit: "Failed to send. Please try again or email us directly.",
  },
};

export type ContactModalText = typeof en;

const de: ContactModalText = {
  subtitle: "Schreib uns",
  closeAria: "Schließen",
  sentTitle: "Nachricht gesendet!",
  sentBody: "Wir melden uns bald bei dir.",
  close: "Schließen",
  firstName: "Vorname",
  lastName: "Nachname",
  firstNamePh: "Erika",
  lastNamePh: "Mustermann",
  email: "E-Mail",
  emailPh: "erika@beispiel.de",
  code: "Vorwahl",
  phone: "Telefon",
  optional: "(opt.)", // longer label wraps on phones
  interestsLabel: "Ich interessiere mich für",
  interestOptions: [
    "Erkunden | Online | Kostenlos",
    "Begleitet | Online | Vor Ort",
    "Wochenende | Retreat",
    "Selbst machen | Kit",
    "Sonstiges",
  ],
  message: "Nachricht",
  messagePh: "Deine Nachricht…",
  sending: "Wird gesendet…",
  send: "Nachricht senden",
  followUs: "Folge uns",
  errors: {
    required: "Pflichtfeld",
    invalidEmail: "Ungültige E-Mail",
    invalidPhone: "Ungültige Nummer",
    selectOne: "Wähle mindestens eine Option",
    submit: "Senden fehlgeschlagen. Bitte versuch es noch mal oder schreib uns direkt eine E-Mail.",
  },
};

export const contactModalText: ByLang<ContactModalText> = { en, de };
export const useContactModalText = () => useL(contactModalText);
